import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button} from 'reactstrap';
import {FormattedMessage} from "react-intl";
import GroupUserEditModal from "./GroupUserEditModal";
import GroupUserBlockModal from "./GroupUserBlockModal";
import GroupUserDeleteModal from "./GroupUserDeleteModal";

class GroupUsersActions extends Component {

  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
      editModal: false,
      blockModal: false,
      deleteModal: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle(property) {
    this.setState({
      [property]: !this.state[property]
    })
  }

  render() {
    const {user, group} = this.props;

    return (
      <ul className="float-right mb-0 p-0">
        <li className="float-left mr-2">
          <Button color="" className="m-0 p-0"> <a onClick={() => this.toggle('editModal')}><i className="fas fa-edit"/></a></Button>
        </li>
        <li className="float-left">
          <Dropdown isOpen={this.state.dropdownOpen} toggle={() => this.toggle('dropdownOpen')} className={'dd-' + user.id}>
            <DropdownToggle className="m-0 p-0" color="" data-toggle={'dd-' + user.id}>
              <span className="fas fa-ellipsis-v" />
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => this.toggle('blockModal')} tag={"a"}>
                <p><i className={user.blocked ? 'fas fa-toggle-off' : 'fas fa-toggle-on'}/></p> {user.blocked ? <FormattedMessage tagName="h5" id="groupUsersActions.button.disable"/> : <FormattedMessage tagName="h5" id="groupUsersActions.button.enable"/>}
              </DropdownItem>
              <DropdownItem onClick={() => this.toggle('deleteModal')} tag={"a"}>
                <p><i className="fas fa-trash" /></p> <FormattedMessage tagName="h5" id="_.button.delete" />
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </li>
        <GroupUserEditModal isOpen={this.state.editModal} toggleModal={() => this.toggle('editModal')} user={user} group={group}/>
        <GroupUserBlockModal isOpen={this.state.blockModal} toggleModal={() => this.toggle('blockModal')} user={user} group={group}/>
        <GroupUserDeleteModal isOpen={this.state.deleteModal} toggleModal={() => this.toggle('deleteModal')} user={user} group={group}/>
      </ul>
    )
  }
}

GroupUsersActions.propTypes = {
  user: PropTypes.object.isRequired,
  group: PropTypes.object.isRequired,
};

export default GroupUsersActions;